import axios from "axios";
import { isMasterView, getSelectedTenant, getActiveStore } from "@/lib/scope";

const API = process.env.REACT_APP_API_BASE_URL || `${(process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "")}/api/v1`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const appearanceControl = (config.method === "put" && config.url === "/appearance") || (config.method === "post" && /^\/appearance\/assets\/(logo|favicon)$/.test(config.url));
  const masterControl = config.method === "post" && (config.url?.startsWith("/master/platform/") || ["/master/tenants", "/master/backup/save", "/master/backup/probe", "/master/backup/test", "/master/backup/run", "/master/product-copy/preview", "/master/product-copy/apply"].includes(config.url));
  if (isMasterView() && !["get", "head", "options"].includes(config.method || "get") && config.url !== "/auth/login" && !masterControl && !appearanceControl) {
    return Promise.reject(new Error("Master hanya dapat melihat data tenant"));
  }
  const token = localStorage.getItem("pos_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  const tenant = getSelectedTenant();
  if (tenant) config.headers["X-Tenant-Id"] = tenant;
  const store = getActiveStore();
  if (store && !config.headers["X-Store-Id"]) config.headers["X-Store-Id"] = store;
  return config;
});

export function apiError(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Terjadi kesalahan";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((d) => (d?.msg ? d.msg : JSON.stringify(d))).join(", ");
  return String(detail);
}
